export const SURVEY_TYPE = 'survey';
export const TEMPLATE_TYPE = 'template';
